import React from 'react';
import { 
  Table, TableBody, TableCell, TableContainer, 
  TableHead, TableRow, Paper, Box, Chip 
} from '@mui/material';

export const EnhancedTable = ({ data, columns, columnTypes, maxHeight = 400, title }) => (
  <TableContainer component={Paper} sx={{ maxHeight, boxShadow: 2 }}>
    <Table stickyHeader>
      <TableHead>
        <TableRow>
          {columns.map(col => (
            <TableCell key={col} sx={{ fontWeight: 'bold' }}>
              <Box display="flex" alignItems="center" gap={1}>
                {col.replace(/_/g, ' ')}
                <Chip 
                  label={columnTypes[col]} 
                  size="small" 
                  color={columnTypes[col] === 'numeric' ? 'primary' : 
                         columnTypes[col] === 'datetime' ? 'secondary' : 'default'}
                />
              </Box>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {data.map((row, index) => (
          <TableRow key={index} hover>
            {columns.map(col => (
              <TableCell key={col}>
                {typeof row[col] === 'number' ? row[col].toLocaleString() : String(row[col])}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);
